import React, { useEffect, useState } from "react";
import {
    Page,
    SubmitButton,
    required,
    FormGroup,
    DatePicker,
} from "components/common";
import { Control, actions, Errors } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useForm } from "hooks";
import { Trans } from "react-i18next";
import Select from "react-select";
import { isCurrency } from "services/util";
import { validationMessage } from "constants/validationMsg";
import { convertTypes } from "pages/Payroll/Provisions/Edit";
import { HistoryAndNotes } from "components";

export const Edit = ({ t, url = "allowance_rules", model = "local", _payroll, match, updateList, id, amountTypesOptions, client, setSettingsMessage }) => {

    const { dispatch, setValue, Form, save, loaded, load, getTitle, value } = useForm({
        model,
    });

    async function onSubmit(item) {
        try {
            await save(_payroll, url, item);
            
            if (!item.allowance_debit_account) {
                setSettingsMessage(t('Please configure the required allowance accounts in Account Settings before using Allowance Rules.'))
            }

            NotificationManager.success(t("Saved successfully"));
            updateList()

        } finally {
            dispatch(actions.setPending(model, false));
        }
    }
    useEffect(
        () => {
            setSettingsMessage('')
            void (async () => {
                const item = await load(_payroll, url, id, {});
                setValue(item);
            })()
            if (amountTypesOptions) {
                amountTypesOptions = convertTypes(amountTypesOptions, t)
            }
        }
        ,
        [id]
    );

    const handleKeyUp = e => {
        if (e.target.value.trim().length == 0) e.target.value = e.target.value.trim();
    };

    if (!loaded) return null;

    return (

        <Form
            onSubmit={onSubmit}
            validators={{
                description: { required },
                amount: {
                    required,
                    isCurrency: (val) => isCurrency(val, { min: 0.01 }),
                    max: (val) => { return !(val && (value.amount_type === 'PERC' && val > 100)) },
                },
                amount_type: { required },
            }}
        >
            <div className="row">
                <div className="col-12">
                    <FormGroup label="Description *" model=".description" >
                        <Control.text
                            model=".description"
                            updateOn="blur"
                            placeholder="Allowance Rule Description"
                            onKeyUp={handleKeyUp} />
                        <Errors
                            className="form-text small text-danger"
                            model=".description"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED),
                            }}
                        />
                    </FormGroup>
                </div>
                <div className="col-12">
                    <FormGroup
                        label="Amount Type *"
                        model=".amount_type"
                        addControlClass={false}>
                        <Control.text style={{ backgroundColor: '#F4F7FE' }}
                            placeholder="Allowance Rule Amount Type"
                            model=".amount_type"
                            component={Select}
                            options={amountTypesOptions.map((x) => ({ value: x.id, label: x.text }))}
                            simpleValue
                            clearable={false}
                            searchable={false}
                        />
                        <Errors
                            className="form-text small text-danger"
                            model=".amount_type"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED)
                            }}
                        />
                    </FormGroup>
                </div>
                <div className="col-12">
                    <FormGroup label="Amount *" model=".amount" >
                        <Control.text model=".amount" updateOn="blur" onKeyUp={handleKeyUp}
                            placeholder="Allowance Rule amount" />
                        <Errors
                            className="form-text small text-danger"
                            model=".amount"
                            show="touched"
                            messages={{
                                required: t(validationMessage.REQUIRED),
                                isCurrency: (val) => val && t(validationMessage.MINIMUM_CURRENCY_VALUE),
                                max: t(validationMessage.MAXIMUM_PERCENTAGE_VALUE),
                            }}
                        />
                    </FormGroup>
                </div>

            </div>
            <div className="mt-2 mb-2" style={{ float: "right" }}>
                <SubmitButton>
                    {id === "new" ?
                        <Trans>Add</Trans>
                        :
                        <Trans>Save</Trans>
                    }
                </SubmitButton>
            </div>

            <hr />

            <HistoryAndNotes
                item={value}
                contentType={'allowancerules'}
                client={client}
                t={t}
            />
        </Form>
    );
};

export default Edit;
